import { render, staticRenderFns } from "./OverlapPreferences.vue?vue&type=template&id=31d55f02&"
import script from "./OverlapPreferences.vue?vue&type=script&lang=js&"
export * from "./OverlapPreferences.vue?vue&type=script&lang=js&"
import style0 from "./OverlapPreferences.vue?vue&type=style&index=0&id=31d55f02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports